import type { JSX } from 'react';
import { Badge, Group, Text, Tooltip } from '@mantine/core';
import type { OrigemDoNome } from '../lib/api.js';

/**
 * Nome do aluno com a origem visível.
 *
 * Quando vem do `pushName`, a secretaria precisa saber que NINGUÉM conferiu
 * aquele nome — é o que a própria pessoa pôs no perfil do WhatsApp, não um
 * cadastro. Tratar os dois igual levaria a confiar num dado que o aluno
 * escreveu sobre si mesmo.
 *
 * O selo é discreto de propósito: o nome continua sendo a informação, e a
 * procedência é a nota de pé. E o selo tem TEXTO, não só cor — num tema
 * escuro, ou para quem não distingue cores, a cor sozinha não diria nada.
 *
 * Renderiza TEXTO, nunca HTML: o `pushName` é texto livre de quem escreve, e
 * nenhum caminho do painel passa por `innerHTML`.
 */
export function NomeDoAluno({
  nome,
  origem,
  semNome = '(sem nome)',
}: {
  nome: string | null;
  origem: OrigemDoNome | null;
  semNome?: string;
}): JSX.Element {
  if (!nome) {
    return (
      <Text size="sm" c="dimmed">
        {semNome}
      </Text>
    );
  }
  return (
    <Group gap={6} wrap="nowrap">
      <Text size="sm">{nome}</Text>
      {origem === 'whatsapp' && (
        <Tooltip label="nome do perfil do WhatsApp; não conferido por ninguém">
          <Badge color="teal" size="xs" variant="light">
            nome do WhatsApp
          </Badge>
        </Tooltip>
      )}
    </Group>
  );
}
